import { AttachmentIcon } from './AttachmentIcon';

/**
 * author: Google
 * id E3C20B38-A6D3-4EF0-817D-863B25E555BA
 * name attachment
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/attachment.svg
 * tags
 */
export const PaperclipHorizontalIcon = AttachmentIcon;
export default PaperclipHorizontalIcon